import React from "react";
import { motion } from "framer-motion";

const loadingDot = {
  width: "0.70rem",
  height: "0.70rem",
  borderRadius: "50%",
  margin: "0 2px",
};

const loadingContainer = {
  width: "inherit",
  height: "inherit",
  display: "flex",
  justifyContent: "space-around",
};

const containerVariants = {
  initial: {
    transition: {
      staggerChildren: 0.2,
    },
  },
  animate: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const dotVariants = {
  initial: {
    y: "-30%",
  },
  animate: {
    y: "80%",
  },
};

const dotTransition = {
  duration: 0.5,
  repeat: Infinity,
  repeatType: "reverse",
  ease: "easeInOut",
};

export default function LoadingDots({ color }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "0.4rem",
      }}
    >
      <motion.div
        style={loadingContainer}
        variants={containerVariants}
        initial="initial"
        animate="animate"
      >
        <motion.span
          style={{ ...loadingDot, backgroundColor: color }}
          variants={dotVariants}
          transition={dotTransition}
        />
        <motion.span
          style={{ ...loadingDot, backgroundColor: color }}
          variants={dotVariants}
          transition={dotTransition}
        />
        <motion.span
          style={{ ...loadingDot, backgroundColor: color }}
          variants={dotVariants}
          transition={dotTransition}
        />
      </motion.div>
    </div>
  );
}
